import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 56,
      width: "100%",
      background: "#FFFFFF",
      borderBottom: "1px solid #EEF1F6",
      zIndex: 9,
      boxSizing: "border-box",
    },

    container: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 24px",
      boxSizing: "border-box",
      direction: "ltr",
    },

    leftSection: {
      display: "flex",
      alignItems: "center",
      gap: 16,
      justifyContent: "flex-start",
    },

    rightSection: {
      width: 280,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    },

    userBox: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      cursor: "pointer",
      direction: "ltr",
    },

    arrowIcon: {
      fontSize: "20px !important",
      color: "#6E758D",
    },

    avatar: {
      width: "28px !important",
      height: "28px !important",
      fontSize: "12px !important",
      backgroundColor: "#DDF3FF !important",
      color: "#5B8DAE !important",
    },

    userName: {
      fontFamily: "Noto Sans Hebrew",
      fontWeight: "400 !important",
      fontStyle: "normal",
      fontSize: "12px !important",
      leadingTrim: "cap-height",
      lineHeight: "24px !important",
      letterSpacing: "0.1px",
      textAlign: "right",
      color: "#6E758D",
      whiteSpace: "nowrap",
    },

    notificationBox: {
      width: 28,
      height: 28,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },

    notificationIcon: {
      fontSize: "20px !important",
      color: "#6E758D",
    },

    search: {
      width: "100%",

      "& .MuiOutlinedInput-root": {
        height: 32,
        borderRadius: 4,
        background: "#FFFFFF",
        direction: "ltr",
        paddingLeft: "8px",
        paddingRight: "8px",

        "& fieldset": {
          borderColor: "#E5EAF2",
        },

        "&:hover fieldset": {
          borderColor: "#D5DCE8",
        },

        "&.Mui-focused fieldset": {
          borderColor: "#D5DCE8",
        },
      },

      "& .MuiOutlinedInput-input": {
        padding: "5px 8px",
        fontSize: 13,
        color: "#6E758D",
        textAlign: "right",
        fontFamily: "Mona-Sans",
        direction: "rtl",
      },

      "& .MuiOutlinedInput-input::placeholder": {
        color: "#9AA3B5",
        opacity: 1,
        textAlign: "right",
      },
    },

    searchIcon: {
      fontSize: "26px !important",
      color: "#6E758D",
      marginRight: 6,
      transform: "scaleX(-1)",
      display: "flex",
      alignItems: "center",
    },

    versionInfo: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "#aaa",
      padding: "10px 16px",
      fontSize: "12px !important",
    },

    logoutModal: {
      position: "absolute",
      background: "#FFFFFF",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "560px",
      minHeight: "182px",
      border: "0px",
      boxShadow: "0",
      zIndex: "9999",
    },

    CardActions: {
      justifyContent: "center",
      marginTop: "30px",
      marginRight: "28px",
    },

    cardContent: {
      marginLeft: "17px",
      marginTop: "12px",
    },

    bodyTypography: {
      fontWeight: "400 !important",
      fontSize: "16px !important",
      lineHeight: "24px !important",
      letterSpacing: "0.5px !important",
      color: "rgba(0, 0, 0, 0.6)",
    },

    headTypography: {
      color: "#000000",
      fontWeight: "550 !important",
      fontSize: "21.5px !important",
      lineHeight: "24px !important",
      letterSpacing: "0.15px !important",
    },

    btnNo: {
      color: "#88929C !important",
      paddingRight: "38px !important",
      fontWeight: "500 !important",
      fontSize: "14px !important",
      lineHeight: "16px !important",
      letterSpacing: "0.0125rem !important",
    },

    btnLogout: {
      fontWeight: "500 !important",
      fontSize: "14px !important",
      lineHeight: "16px !important",
      letterSpacing: "0.0125rem !important",
    },
  })
);